"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionManager = void 0;
/**
 * Static helper class for managing conversation sessions
 */
class SessionManager {
    /**
     * Generate a unique temporary session key
     */
    static generateTempKey() {
        return `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }
    /**
     * Store pending session callbacks with a temporary key
     */
    static storePendingCallback(pendingCallbacks, tempKey, callbacks) {
        pendingCallbacks.set(tempKey, callbacks);
    }
    /**
     * Move pending callbacks to active sessions when session is confirmed
     */
    static activatePendingSession(activeSessions, pendingCallbacks, tempKey, sessionId) {
        if (!tempKey || !pendingCallbacks.has(tempKey) || !sessionId) {
            return null;
        }
        const callbacks = pendingCallbacks.get(tempKey);
        pendingCallbacks.delete(tempKey);
        activeSessions.set(sessionId, callbacks);
        return callbacks;
    }
    /**
     * Clean up a session and all related data
     */
    static cleanupSession(activeSessions, streamingSessions, pendingCallbacks, sessionId) {
        // Clean up active session
        activeSessions.delete(sessionId);
        // Clean up streaming session
        streamingSessions.delete(sessionId);
        // Clean up any pending callbacks that might reference this session
        // (Safety measure in case session ended before fully started)
        for (const [tempKey, callbacks] of pendingCallbacks.entries()) {
            pendingCallbacks.delete(tempKey);
            break; // Typically only one pending session at a time
        }
    }
    /**
     * Check if a session is currently streaming
     */
    static isStreamingActive(streamingSessions, sessionId) {
        return streamingSessions.get(sessionId) || false;
    }
    /**
     * Check if a session is active
     */
    static isSessionActive(activeSessions, sessionId) {
        return activeSessions.has(sessionId);
    }
    /**
     * Mark a session as streaming
     */
    static setStreamingActive(streamingSessions, sessionId, active) {
        if (active) {
            streamingSessions.set(sessionId, true);
        }
        else {
            streamingSessions.delete(sessionId);
        }
    }
    /**
     * Get all active streaming session IDs
     */
    static getStreamingSessionIds(streamingSessions) {
        return Array.from(streamingSessions.keys());
    }
    /**
     * Clear all sessions and streaming data
     */
    static clearAllSessions(activeSessions, streamingSessions, pendingCallbacks) {
        activeSessions.clear();
        streamingSessions.clear();
        pendingCallbacks.clear();
    }
}
exports.SessionManager = SessionManager;
